import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OrderformCartProductItem } from '../../fascades/product-list.fascade';
import {
  OrderformGlobalSettings,
  OrderformPrice,
  OrderformSelectedPlan,
} from '@orderform/widgets';
import { OrderformFascade } from '../../fascades/orderform.fascade';

type ProductListItemPriceDisplay =
  | 'unit_amounts'
  | 'total_amounts'
  | 'total_amounts_undiscounted'
  | 'shipping_amounts';

@Component({
  selector: 'orderform-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPriceComponent {
  @Input() product: OrderformCartProductItem;
  @Input() display: ProductListItemPriceDisplay;
  @Input() displayDiscount: ProductListItemPriceDisplay;
  @Input() showDiscount = false;
  @Input() withoutInterval = false;

  public globalSettings$ = this._orderformFascade.globalSettings$;
  public orderSelectedPlan$ = this._orderformFascade.selectedPlan$;

  constructor(private _orderformFascade: OrderformFascade) {}

  haveRebilling(
    product: OrderformCartProductItem,
    globalSettings: OrderformGlobalSettings
  ) {
    return +this._getAmountValue(product.unit_amounts.oth, globalSettings) > 0;
  }

  showOtherRebillingAmount(
    product: OrderformCartProductItem,
    plan: OrderformSelectedPlan,
    globalSettings: OrderformGlobalSettings
  ) {
    return (
      // show other if "oth"-payment exists or two payments activated
      this._getAmountValue(product.unit_amounts.oth, globalSettings) ||
      plan.number_of_installments === 2
    );
  }

  private _getAmountValue(
    price: OrderformPrice,
    globalSettings: OrderformGlobalSettings
  ): number {
    return price[globalSettings.is_vat_shown ? 'net' : 'gross'];
  }
}
